import { FunctionComponent, default as React } from 'react'
import { Link, NavLink } from 'react-router-dom'
import cn from 'classnames'

const HeaderRootMenu: FunctionComponent = () => (
  <nav className="menu">
    <NavLink
      className={({ isActive }) =>
        isActive ? 'menu_root-link link -active' : 'menu_root-link link'
      }
      to="/clients"
    >
      Clients
    </NavLink>
    <NavLink
      className={({ isActive }) =>
        isActive ? 'menu_root-link link -active' : 'menu_root-link link'
      }
      to="/orders"
    >
      Orders
    </NavLink>
    {/*<NavLink*/}
    {/*  className={({ isActive }) =>*/}
    {/*    isActive ? 'menu_root-link link -active' : 'menu_root-link link'*/}
    {/*  }*/}
    {/*  to="/invoices"*/}
    {/*>*/}
    {/*  Invoices*/}
    {/*</NavLink>*/}
    <NavLink
      className={({ isActive }) =>
        isActive ? 'menu_root-link link -active' : 'menu_root-link link'
      }
      to="/users"
    >
      Internal Users
    </NavLink>
    <NavLink
      className={({ isActive }) =>
        isActive ? 'menu_root-link link -active' : 'menu_root-link link'
      }
      to="/messages"
    >
      Messages
    </NavLink>
    <NavLink
      className={({ isActive }) =>
        isActive ? 'menu_root-link link -active' : 'menu_root-link link'
      }
      to="/product-attributes"
    >
      Product Attributes
    </NavLink>
  </nav>
)

export default HeaderRootMenu
